import React from 'react'
import { connect } from "react-redux";
import VideoThumb from '../video/VideoThumb'
import ResourcesMenu from './ResourcesMenu'
import SearchIcon from '../../images/icons/SearchIcon'
import { practice_types, practices } from '../../reducers'

@connect((store) => {
	return {
		User: store.User,
		app: store.app,
		modal: store.modal,
		toasts: store.toasts,
		sessions: store.sessions,
		therapy_areas: store.therapy_areas,
		therapy_categories: store.therapy_categories,
		connected: store.connected
	}
})
class VideosPageContent extends React.Component {
	constructor(props) {
		super(props);
		this.handleProfessionChange = this.handleProfessionChange.bind(this);
		this.state = {
			professionSelection: this.props.professionSelection
		};
	}

  componentDidUpdate(nextProps) {
		const { professionSelection } = this.props;

		if (professionSelection != nextProps.professionSelection) {
			this.state = {
        professionSelection: this.props.professionSelection
      };
		}
	}

	handleProfessionChange(e) {
		this.setState({ professionSelection: e.target.value });
	}
	
	render() {
		const { 
			videos,
			videoClick,
			search,
			handleSearch,
			category,
			isOnlyParent,
			therapy_areas,
			therapy_categories,
      userType,
      practice_types
		} = this.props;
			// console.log(videos);
		
		const { professionSelection } = this.state;
    // console.log(this.props.practice_types)
    // console.log("this.props.practice_types", this.props.practice_types)
		return (
     
      <main
        className={
          "main areasPageContent " +
          (this.props.practice_types.length > 1 ? "showFilter" : "hideFilter")
        }
      >
        {this.props.practice_types.length > 1 ? (
          <div className="select">
            Profession:
            <select
              value={professionSelection}
              onChange={e => this.handleProfessionChange(e)}
            >
              {this.props.practice_types.map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
            </select>
          </div>
        ) : (
          ""
        )}
        <ResourcesMenu active="areas" show_videos="true" />
        <div className="page mb8">
          <small>Your homework videos will appear here</small>
          <div className="search-box__input">
            <SearchIcon />
            <input
              type="search"
              onChange={handleSearch}
              className="md-input"
              placeholder="Search"
              value={search}
            />
          </div>
          <br />
          <div className="video-grid grid">
			{videos
			.filter(video => video.practice_type == professionSelection)
			.map(video => (
              <VideoThumb
                key={`video-${video._id}`}
                click={videoClick}
                video={video}
              />
            ))}
          </div>
        </div>
      </main>
    );
	}
}

export default VideosPageContent;



// WEBPACK FOOTER //
// ./src/components/home/VideosPageContent.jsx